import { SpartaEmployeeLabor } from './sparta-employee-labor.model';

export interface WorkOrderSummary {
  phaseName: string;
  straightTime: number;
  overtimeHours: number;
  premiumHours: number;
  totalHours: number;
  equipmentHours: number;
  spartaLabors: SpartaEmployeeLabor[];
}
